import React, { useContext, useEffect, useState } from 'react';
import { Map as MapIcon } from 'pcln-icons';
import { Text, Flex, Button, Box } from 'pcln-design-system';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import analytics from '../../analytics/analytics';
import { useChatUIContext } from '../../hooks/useChatUIContext';
/**
 * A button component that opens a map view when clicked. The button is only rendered when
 * there are hotels or location pins to display and the map feature is enabled.
 * In standalone mode, the map opens automatically when pins are available.
 */
export const OpenMapButton = ({
  isLoading,
  isStandalone
}) => {
  const {
    hotelOnMapList,
    locationPinList,
    shouldUseMapFeature
  } = useContext(ChatbotDataContext);
  const [hasPinOnMap, setHasPinOnMap] = useState(false);
  const {
    setIsMapOpened,
    shouldDisplayMapButton
  } = useChatUIContext();
  useEffect(() => {
    const hasPinOnMap = (hotelOnMapList === null || hotelOnMapList === void 0 ? void 0 : hotelOnMapList.length) > 0 || (locationPinList === null || locationPinList === void 0 ? void 0 : locationPinList.length) > 0;
    if (hasPinOnMap && isStandalone) {
      setIsMapOpened(true);
    }
    setHasPinOnMap(hasPinOnMap);
  }, [isStandalone, hotelOnMapList, locationPinList]);
  if (!shouldUseMapFeature || !hasPinOnMap || isLoading || !shouldDisplayMapButton) {
    return null;
  }
  return React.createElement(React.Fragment, null, React.createElement(Box, {
    mt: 3,
    mb: 4,
    style: {
      position: 'relative'
    }
  }, React.createElement(Button, {
    size: 'small',
    style: {
      position: 'absolute',
      bottom: '0',
      left: '50%',
      transform: 'translate(-50%, 15px)'
    },
    onClick: function () {
      analytics.fireGA4Event({
        event: 'map_click',
        attributes: {
          type: 'penny',
          page_name: 'listings',
          product_name: 'hotel'
        }
      });
      setIsMapOpened(true);
    },
    title: 'Open Map'
  }, React.createElement(Flex, null, React.createElement(MapIcon, {
    color: 'lightest',
    size: 16
  }), React.createElement(Text, {
    ml: 1
  }, "Map")))));
};